import { createFileRoute } from "@tanstack/react-router";
import { marketingHead } from "../marketing-content/head";

import { MarketingLayout } from "../components/marketing/MarketingLayout";
import { MarketingPricingPage } from "../components/marketing/MarketingPricingPage";

function PricingPage() {
  return (
    <MarketingLayout>
      <MarketingPricingPage />
    </MarketingLayout>
  );
}

export const Route = createFileRoute("/pricing")({
  head: () => marketingHead("/pricing"),
  component: PricingPage,
});
